/**
 * Normalizes list responses from GET /api/admin/external-api-keys.
 */
export function normalizeExternalApiKeyList(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }
  if (payload?.data && Array.isArray(payload.data)) {
    return payload.data;
  }
  if (payload?.items && Array.isArray(payload.items)) {
    return payload.items;
  }
  return [];
}

/** Field names the API may use for the one-time secret (first match wins). */
const PLAINTEXT_KEY_FIELD_NAMES = [
  "apiKey",
  "key",
  "plainTextKey",
  "token",
  "secret",
];

function firstStringByFieldOrder(obj) {
  for (const name of PLAINTEXT_KEY_FIELD_NAMES) {
    const v = obj[name];
    if (typeof v === "string") {
      return v;
    }
  }
  return null;
}

/**
 * Extracts the one-time secret returned by POST create.
 * Add new names to PLAINTEXT_KEY_FIELD_NAMES if the API uses different keys.
 */
export function pickPlaintextKeyFromCreateResponse(payload) {
  if (payload == null) {
    return "";
  }
  if (typeof payload === "string") {
    return payload;
  }
  if (typeof payload !== "object") {
    return "";
  }
  const direct = firstStringByFieldOrder(payload);
  if (direct != null) {
    return direct;
  }
  if (payload.data) {
    return pickPlaintextKeyFromCreateResponse(payload.data);
  }
  return "";
}

/** List/detail records may use different field names for last use time. */
export const pickLastUse = (k) => k?.lastUse ?? k?.lastUsedAt ?? k?.lastUseAt;
